
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/au/virtual-office-sydney",
      function () {
        return require("private-next-pages/au/virtual-office-sydney.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/au/virtual-office-sydney"])
      });
    }
  